import React from "react";
import { useNavigate, useLocation, UNSAFE_DataRouterContext } from "react-router-dom";
import { userInfo } from "../auth/AuthProvider";
import { useRecoilValue } from "recoil";
import { useTranslation } from "react-i18next";
import MyAppBar from "../components/navigation/MyAppBar";
import MyAppBarDefault from "../components/navigation/MyAppBarDefault";
import { isDebug, utils } from "../utils";


const Header = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const debugPrint = false;
  const [menuMode, setMenuMode] = React.useState(7);

  const loader = () => {
    navigate("/login");
    if (isDebug() && debugPrint) console.log("loader", new Date().toISOString() ,loader);
  };
  const auth = useRecoilValue(userInfo);
  if (isDebug() && debugPrint) console.log("## Header auth", new Date().toISOString() ,auth);
  if (isDebug() && debugPrint) console.log("## Header pathname", new Date().toISOString() ,pathname);
  
  const { t, i18n } = useTranslation();
  const [isLanguageMenuOpen, setLanguageMenuOpen] = React.useState(false);
  const handleChangeLanguage = (lang) => {
    try {
      utils.web.localStorageSave("i18nLang", lang);
    }
    catch (err)
    {
        console.error("Failed to save language to localStorage:", err);
    }
    finally {
      i18n.changeLanguage(lang);
      setLanguageMenuOpen(false);
    }
  };

  /*
    2025.04.03
    position="fixed" 헤더 메뉴가 떠 있는 것과 같음으로 바디 페이지의 Top Padding을 Header 높이 만큼 설정하여야 한다.
                      수정하면 App.js 파일을 수정하여 처리함
                      REACT_APP_HEADER_SIZE 설정 값을 참조한다.
    position="static" 이면 헤더 메뉴도 페이지에 포함되어 스크롤될때 메뉴도 올라가버리는 문제가 있음
  */
  return (
    <>
      {menuMode === 7 ?
      <MyAppBar auth={auth} t={t} handleChangeLanguage={handleChangeLanguage} i18n={i18n} /> :
      <MyAppBarDefault auth={auth} t={t} /> }
      </>
  );
};

export default Header;
